import { CdpaRequest } from "../cdpaRequest";
import { Slugs } from "../slug.loader";
import { ValidityState } from "./baseValidator";
export async function getRegisterUsernameValidityState(username) {
    if (!username) {
        return { valid: ValidityState.Invalid, reason: Slugs.translated.requiredFieldsMustBeValid };
    }
    try {
        const userTagRequest = await CdpaRequest.validateUsername(username);
        if (!userTagRequest.valid) {
            return {
                valid: ValidityState.Invalid,
                reason: Slugs.translated.invalidUsername
            };
        }
        return { valid: ValidityState.BackendValid };
    }
    catch (error) {
        console.error(error);
        return { valid: ValidityState.Indeterminate };
    }
}
